export const isFieldEmpty = (text): boolean => {
  if (text.length > 1) {
    return false
  }
  const element = text[0]
  if (element.length > 1) {
    return false
  }
  if ('children' in element && element.children.length > 1) {
    return false
  }
  return 'children' in element && element.children[0].text === ''
}
